export class BuildingTypeModel{
  id:number;
  name:string;
  color:string;
}
